import { DataSource } from '@/shared/models/data/data-source'
import { ResourceViewModel } from '@/business/resource/interfaces/resource-view-model'
import { SearchRequest } from '@/shared/interfaces/search-request'
import { PageResponse } from '@/shared/interfaces/page-response'
import { Injector } from '@/config/dependency-injection'
import { ResourceModule } from '@/business/resource/store/resource-module'
import { ResourceVariant } from '@/api/generated'
import { ExtendedBlob } from '@/shared/models/extended-blob'

export class ResourceDataSource extends DataSource<ResourceViewModel> {
  private initialized = false
  private loading = false
  private resourceModule = Injector.get(ResourceModule)

  // We want to load all resources for now
  private page = 1
  private pageSize = 10000

  get items(): ResourceViewModel[] {
    return this.resourceModule.resources
      .filter(item => item.hidden !== true)
      .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
      .map(item => ({
        ...item,
        variants: item.variants?.filter(variant => variant.hidden !== true),
      }))
  }

  public createVariant(file: ExtendedBlob, resource: ResourceViewModel): Promise<ResourceVariant> {
    return this.resourceModule.createVariant({
      file,
      resource: {
        description: resource.description,
        name: resource.name,
        originalId: resource.id,
        type: resource.type,
      },
    })
  }

  public destroy(): void {
    this.resourceModule.cleanup()
  }

  public fetchData(request: SearchRequest): Promise<PageResponse<ResourceViewModel>> {
    this.loading = true

    return this.resourceModule
      .fetchResources({
        page: this.page,
        pageSize: this.pageSize,
        query: request.query,
      })
      .finally(() => {
        this.initialized = true
        this.loading = false
      })
  }

  public isLoading(): boolean {
    return this.loading
  }
}
